// Auto-generated file created by SVGR source illustrationTemplate.ts
// DO NOT EDIT THIE FILE
import { SVGUniqueID } from './svg-unique-id';
import type { IllustrationProps } from './types';
const Illustration = (props: IllustrationProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    width={92}
    height={68}
    viewBox="0 0 92 68"
    {...props}
  >
    <path
      d="M34.0664 0.118131L77.1565 17.9666C77.3788 18.0587 77.5689 18.2147 77.7026 18.4148C77.8363 18.6149 77.9076 18.8501 77.9076 19.0908V54.9378L33.5127 36.5489V0.488131C33.5127 0.422271 33.5289 0.357427 33.56 0.299344C33.591 0.24126 33.6359 0.19173 33.6907 0.15514C33.7454 0.11855 33.8084 0.0960303 33.8739 0.089575C33.9395 0.0831197 34.0056 0.0929277 34.0664 0.118131Z"
      fill="#F1F1F3"
    />
    <path
      d="M77.9953 55.068L77.8748 55.018L33.426 36.6067V0.487779C33.426 0.407574 33.4457 0.328599 33.4835 0.257854C33.5213 0.18711 33.576 0.12678 33.6427 0.0822113C33.7093 0.0376425 33.786 0.0102109 33.8658 0.00234846C33.9456 -0.00551395 34.0262 0.006436 34.1003 0.0371377L77.1903 17.8856C77.4289 17.9839 77.6328 18.1509 77.7762 18.3655C77.9196 18.58 77.9958 18.8324 77.9953 19.0904V55.068ZM33.6004 36.4903L77.8209 54.8069V19.0904C77.8214 18.8669 77.7553 18.6483 77.6311 18.4625C77.5069 18.2766 77.3302 18.1319 77.1236 18.0468L34.0335 0.198329C33.9859 0.17862 33.9342 0.170953 33.8829 0.176008C33.8317 0.181062 33.7824 0.198683 33.7396 0.227306C33.6968 0.25593 33.6617 0.294673 33.6374 0.340107C33.6131 0.385541 33.6004 0.436263 33.6004 0.487779V36.4903Z"
      fill="#37363F"
    />
    <path
      d="M66.7854 19.6106H66.6111V50.47H66.7854V19.6106Z"
      fill="#37363F"
    />
    <path
      d="M77.9949 24.3842L77.8744 24.3343L33.6 5.99521V6.13629H33.4257V2.57666L33.5462 2.62658L77.9949 21.038V24.3842ZM33.6 5.80646L77.8206 24.1232V21.1544L33.6 2.83769V5.80646Z"
      fill="#37363F"
    />
    <path
      d="M34.0652 0.20327L77.1784 18.0613C77.3943 18.1507 77.5787 18.3021 77.7085 18.4964C77.8383 18.6906 77.9076 18.919 77.9076 19.1527V21.0966L33.5127 2.70761V0.57245C33.5127 0.506736 33.5289 0.442035 33.5599 0.38408C33.5909 0.326125 33.6356 0.276705 33.6903 0.240196C33.7449 0.203687 33.8077 0.181217 33.8731 0.174776C33.9385 0.168335 34.0045 0.178122 34.0652 0.20327Z"
      fill="#37363F"
    />
    <path
      d="M77.9949 21.2267L77.8744 21.1768L33.4257 2.7654V0.571995C33.4257 0.491949 33.4454 0.413139 33.4831 0.342544C33.5209 0.271949 33.5754 0.211749 33.642 0.167272C33.7085 0.122795 33.785 0.095415 33.8647 0.0875567C33.9443 0.0796984 34.0247 0.0916048 34.0987 0.12222L77.2119 17.9803C77.4439 18.0759 77.6424 18.2384 77.7818 18.4471C77.9213 18.6557 77.9954 18.9012 77.9949 19.1522V21.2267ZM33.6 2.64893L77.8206 20.9657V19.1522C77.821 18.9357 77.757 18.724 77.6367 18.544C77.5164 18.3641 77.3453 18.224 77.1451 18.1415L34.0319 0.283411C33.9845 0.26375 33.9329 0.256099 33.8818 0.261132C33.8307 0.266166 33.7816 0.283729 33.7389 0.312268C33.6961 0.340807 33.6611 0.379439 33.6369 0.424743C33.6127 0.470047 33.6 0.520624 33.6 0.571995V2.64893Z"
      fill="#37363F"
    />
    <path
      d="M34.6501 4.20617C34.4508 4.12564 34.3158 4.22214 34.3166 4.438C34.3176 4.53477 34.3419 4.62987 34.3876 4.7152C34.4332 4.80053 34.4988 4.87356 34.5787 4.92809L34.6602 4.99277C34.7656 5.07643 34.8186 5.12618 34.8189 5.20107C34.8191 5.27596 34.7589 5.301 34.6611 5.2615C34.6043 5.23027 34.5558 5.1857 34.5199 5.13162C34.484 5.07754 34.4618 5.01555 34.4551 4.95099L34.2874 4.96677C34.3374 5.26268 34.4905 5.43302 34.662 5.50233C34.8826 5.59146 35.0162 5.49244 35.0154 5.26091C35.0136 5.1631 34.9879 5.06722 34.9405 4.98167C34.893 4.89612 34.8253 4.82352 34.7433 4.77023L34.6605 4.70648C34.5753 4.64028 34.5162 4.58609 34.5159 4.50434C34.5156 4.43631 34.5645 4.41159 34.652 4.44693C34.7041 4.47127 34.7486 4.50922 34.781 4.55677C34.8133 4.60432 34.8321 4.65971 34.8356 4.71709L35.0083 4.72283C35 4.61262 34.9625 4.50661 34.8995 4.41578C34.8365 4.32495 34.7504 4.25258 34.6501 4.20617"
      fill="#37363F"
    />
    <path
      d="M35.3918 5.61052C35.3588 5.59966 35.3299 5.57907 35.3088 5.55145C35.2877 5.52383 35.2755 5.49047 35.2738 5.45577C35.2735 5.38822 35.3197 5.36778 35.3911 5.39661C35.424 5.40742 35.4529 5.42794 35.474 5.45546C35.495 5.48299 35.5073 5.51625 35.5091 5.55086C35.5094 5.6189 35.4632 5.63934 35.3918 5.61052ZM35.3904 4.82543C35.2614 4.77332 35.1464 4.79968 35.098 4.98104L35.2514 5.13733C35.2747 5.06172 35.3185 5.02954 35.3837 5.05587C35.4233 5.07279 35.4564 5.10202 35.4782 5.13923C35.4999 5.17644 35.5091 5.21966 35.5043 5.26249L35.5046 5.33739C35.469 5.2747 35.4133 5.22585 35.3465 5.19873C35.1801 5.13151 35.0838 5.21185 35.0844 5.38318C35.0812 5.4657 35.1033 5.54723 35.1476 5.61692C35.1919 5.68661 35.2564 5.74114 35.3325 5.77325C35.3626 5.79178 35.3987 5.79829 35.4334 5.79151C35.4682 5.78473 35.4991 5.76514 35.5201 5.73663L35.5204 5.82572L35.6906 5.89447L35.6885 5.31246C35.6933 5.21075 35.6675 5.10994 35.6143 5.0231C35.5612 4.93626 35.4831 4.86739 35.3904 4.82543"
      fill="#37363F"
    />
    <path
      d="M35.9837 4.7687L35.7985 4.69385L35.802 5.65717C35.8026 5.83535 35.8757 5.96949 35.9996 6.01953L36.0823 6.05293L36.0814 5.82874L36.0365 5.81058C36.0025 5.79686 35.9873 5.76579 35.9871 5.71587L35.9837 4.7687Z"
      fill="#37363F"
    />
    <path
      d="M36.3194 5.57098C36.3352 5.46688 36.3775 5.43267 36.4465 5.46053C36.5079 5.48534 36.553 5.55343 36.5709 5.67259L36.3194 5.57098V5.57098ZM36.4457 5.252C36.2567 5.17563 36.1257 5.32211 36.1267 5.60847C36.1278 5.90069 36.2626 6.14923 36.4592 6.22865C36.5971 6.28438 36.712 6.22913 36.759 6.04183L36.6033 5.90072C36.5721 6.00545 36.5222 6.03171 36.4498 6.00247C36.3757 5.97252 36.3254 5.89355 36.3149 5.74317L36.7572 5.92184C36.7585 5.90477 36.7584 5.88177 36.7583 5.86366C36.7573 5.57534 36.63 5.32644 36.4457 5.25201"
      fill="#37363F"
    />
    <path
      d="M37.1094 5.52192C36.9451 5.45553 36.8401 5.52507 36.8408 5.6959C36.8413 5.84764 36.9082 5.96313 37.0624 6.07921L37.1253 6.12563C37.1981 6.17998 37.2294 6.21217 37.2296 6.25868C37.2297 6.30469 37.1897 6.31538 37.1245 6.28905C37.0796 6.26701 37.0414 6.23354 37.0136 6.19201C36.9858 6.15048 36.9694 6.10236 36.9661 6.05249L36.8198 6.06282C36.8292 6.1554 36.8622 6.24402 36.9157 6.32015C36.9692 6.39629 37.0413 6.45739 37.1253 6.49758C37.2934 6.56551 37.4044 6.49307 37.4038 6.31636C37.4016 6.2422 37.3814 6.16969 37.3449 6.10507C37.3084 6.04045 37.2568 5.98565 37.1945 5.94538L37.132 5.8991C37.054 5.84071 37.0138 5.81031 37.0137 5.76038C37.0135 5.72121 37.0498 5.70556 37.1102 5.72996C37.1492 5.74762 37.1825 5.77592 37.2063 5.81162C37.23 5.84732 37.2433 5.88898 37.2445 5.93184L37.3959 5.93633C37.3904 5.84772 37.3608 5.7623 37.3103 5.68927C37.2598 5.61624 37.1904 5.55838 37.1094 5.52193"
      fill="#37363F"
    />
    <path
      d="M37.7025 6.04981L37.7012 5.70815L37.8443 5.76595C37.8889 5.78418 37.9267 5.81602 37.9522 5.85695C37.9777 5.89787 37.9896 5.94579 37.9863 5.99389C37.9867 6.10794 37.933 6.14296 37.8455 6.10761L37.7025 6.04981H37.7025ZM37.8558 5.52521L37.5051 5.38354L37.5096 6.6298L37.7049 6.70867L37.7033 6.28673L37.8612 6.35049C38.0742 6.43657 38.1927 6.3246 38.1918 6.07692C38.1985 5.96171 38.1699 5.84719 38.1099 5.74863C38.0498 5.65006 37.9612 5.57213 37.8558 5.52521Z"
      fill="#37363F"
    />
    <path
      d="M38.5772 6.85287C38.4917 6.81836 38.4276 6.70153 38.427 6.53755C38.4264 6.37406 38.4899 6.31075 38.5753 6.34526C38.6618 6.38019 38.7273 6.49562 38.7279 6.65911C38.7285 6.82309 38.6636 6.8878 38.5772 6.85287ZM38.5745 6.11178C38.3789 6.03277 38.2355 6.17426 38.2366 6.46061C38.2376 6.74746 38.3824 7.0054 38.578 7.0844C38.7746 7.16383 38.918 7.02233 38.9169 6.73549C38.9159 6.44913 38.7711 6.19121 38.5745 6.11178Z"
      fill="#37363F"
    />
    <path
      d="M39.9089 6.67537L39.7148 6.59693L39.6189 7.10417L39.5041 6.51173L39.3388 6.445L39.2293 6.95012L39.1294 6.36043L38.9329 6.28101L39.1304 7.28361L39.3146 7.35806L39.4218 6.86608L39.5325 7.44609L39.7191 7.52143L39.9089 6.67537Z"
      fill="#37363F"
    />
    <path
      d="M40.1228 7.10751C40.1389 7.00355 40.1812 6.96933 40.2502 6.9972C40.3116 7.02201 40.3567 7.09009 40.3746 7.20926L40.1228 7.10751ZM40.2494 6.78867C40.0601 6.71216 39.9294 6.85878 39.9304 7.14513C39.9315 7.43736 40.0663 7.68589 40.2629 7.76532C40.4008 7.82103 40.5157 7.76579 40.5623 7.57836L40.407 7.43739C40.3758 7.54211 40.3259 7.56837 40.2532 7.53898C40.1794 7.50919 40.1291 7.43021 40.1186 7.27983L40.5609 7.45851C40.5618 7.4413 40.5618 7.41829 40.5617 7.40018C40.5607 7.11187 40.4337 6.86311 40.2494 6.78867Z"
      fill="#37363F"
    />
    <path
      d="M41.0287 7.10388L40.9975 7.09126C40.9323 7.06493 40.8758 7.08463 40.8402 7.17337L40.8397 7.05246L40.6555 6.97803L40.6589 7.90219L40.8431 7.97663L40.8414 7.49595C40.8409 7.37308 40.8908 7.3292 40.9583 7.3565L41.0297 7.38534L41.0287 7.10388Z"
      fill="#37363F"
    />
    <path
      d="M63.6049 22.2591C63.4451 22.1945 63.3825 22.3242 63.3655 22.4493L63.4957 22.562C63.5065 22.4965 63.5315 22.4225 63.6056 22.4525C63.6316 22.4661 63.6531 22.4869 63.6676 22.5123C63.6822 22.5377 63.6891 22.5668 63.6877 22.5961C63.6876 22.6207 63.6823 22.645 63.6722 22.6674C63.6622 22.6899 63.6475 22.71 63.6293 22.7264L63.3822 23.0015L63.3828 23.167L63.848 23.3549L63.8474 23.1674L63.5822 23.0603L63.7391 22.8911C63.773 22.8604 63.7998 22.8229 63.818 22.781C63.8362 22.7391 63.8452 22.6938 63.8444 22.6482C63.848 22.5668 63.8271 22.4862 63.7844 22.4169C63.7417 22.3475 63.6792 22.2925 63.6049 22.2591Z"
      fill="#37363F"
    />
    <path
      d="M64.1967 23.3222C64.1099 23.2871 64.0789 23.1588 64.0782 22.9581C64.0775 22.7579 64.1076 22.6537 64.1944 22.6888C64.2812 22.7239 64.3121 22.8527 64.3129 23.0529C64.3136 23.2536 64.2835 23.3573 64.1967 23.3222V23.3222ZM64.1937 22.4969C64.0369 22.4336 63.9201 22.5502 63.9214 22.8962C63.9226 23.2394 64.0406 23.4512 64.1974 23.5146C64.3542 23.5779 64.4709 23.4609 64.4697 23.1177C64.4684 22.7717 64.3505 22.5603 64.1937 22.4969"
      fill="#37363F"
    />
    <path
      d="M64.7645 22.728C64.6049 22.6636 64.5424 22.7933 64.525 22.9182L64.6556 23.0311C64.666 22.9654 64.6914 22.8916 64.7652 22.9214C64.7912 22.935 64.8127 22.9558 64.8273 22.9813C64.8419 23.0067 64.8489 23.0358 64.8476 23.0651C64.8475 23.0897 64.8422 23.114 64.8321 23.1365C64.822 23.1589 64.8074 23.179 64.7891 23.1955L64.5418 23.4704L64.5424 23.6359L65.0079 23.824L65.0072 23.6365L64.742 23.5294L64.899 23.3601C64.9328 23.3294 64.9596 23.2919 64.9778 23.25C64.9959 23.2081 65.005 23.1629 65.0043 23.1172C65.0079 23.0358 64.9869 22.9552 64.9441 22.8858C64.9014 22.8164 64.8388 22.7615 64.7645 22.728Z"
      fill="#37363F"
    />
    <path
      d="M65.3161 22.9688L65.0704 22.8696L65.0711 23.0576L65.1679 23.0966L65.1707 23.8896L65.3196 23.9498L65.3161 22.9688Z"
      fill="#37363F"
    />
    <path
      d="M35.3611 10.4485L34.793 10.219L34.7937 10.4123L35.0009 10.496L35.0037 11.2836L35.1574 11.3457L35.1546 10.5582L35.3618 10.6418L35.3611 10.4485Z"
      fill="#37363F"
    />
    <path
      d="M35.5522 11.341C35.4849 11.3139 35.4342 11.222 35.4338 11.0933C35.4333 10.9641 35.4835 10.9144 35.5507 10.9416C35.6187 10.9691 35.67 11.0597 35.6705 11.1889C35.671 11.3177 35.6201 11.3685 35.5522 11.341ZM35.55 10.7581C35.396 10.6958 35.2834 10.8072 35.2842 11.0329C35.285 11.2585 35.3988 11.4609 35.5528 11.5231C35.7076 11.5856 35.8202 11.4747 35.8194 11.2491C35.8186 11.0234 35.7048 10.8206 35.55 10.7581Z"
      fill="#37363F"
    />
    <path
      d="M36.078 10.75L35.9326 10.7993L35.9331 10.9324L35.8401 10.8948L35.8407 11.0559L35.9336 11.0935L35.9347 11.3906C35.9353 11.559 36.0036 11.6872 36.1189 11.7338L36.193 11.7638L36.1924 11.5871L36.1371 11.5647C36.0994 11.5495 36.0807 11.5087 36.0805 11.4412L36.0794 11.1524L36.191 11.1974L36.1904 11.0364L36.0789 10.9913L36.078 10.75Z"
      fill="#37363F"
    />
    <path
      d="M36.4769 11.7505C36.451 11.742 36.4282 11.7258 36.4116 11.7041C36.395 11.6824 36.3854 11.6561 36.384 11.6289C36.3838 11.5755 36.42 11.5594 36.4763 11.5821C36.5023 11.5906 36.525 11.6068 36.5416 11.6285C36.5582 11.6502 36.5679 11.6764 36.5693 11.7037C36.5695 11.7571 36.5332 11.7732 36.4769 11.7505V11.7505ZM36.4757 11.1327C36.3742 11.0916 36.2838 11.1123 36.2459 11.2554L36.3663 11.3783C36.3849 11.3184 36.4191 11.2931 36.4705 11.3139C36.5018 11.3272 36.528 11.3503 36.5451 11.3797C36.5623 11.409 36.5695 11.4431 36.5657 11.4769L36.5659 11.5357C36.5378 11.4865 36.494 11.4482 36.4415 11.4268C36.3101 11.3737 36.2346 11.437 36.2351 11.5716C36.2326 11.6365 36.2499 11.7006 36.2847 11.7554C36.3196 11.8102 36.3703 11.853 36.4301 11.8782C36.4538 11.8928 36.4821 11.898 36.5094 11.8928C36.5367 11.8875 36.5611 11.8722 36.5777 11.8498L36.5779 11.9198L36.7121 11.974L36.7104 11.5159C36.7142 11.4358 36.6939 11.3565 36.652 11.2882C36.6102 11.2198 36.5487 11.1657 36.4757 11.1327"
      fill="#37363F"
    />
    <path
      d="M36.9437 11.0875L36.7979 11.0286L36.8006 11.7868C36.7946 11.8445 36.8063 11.9026 36.834 11.9536C36.8618 12.0045 36.9044 12.0458 36.9561 12.072L37.0213 12.0984L37.0207 11.9217L36.985 11.9072C36.9582 11.8964 36.9465 11.8721 36.9464 11.833L36.9437 11.0875Z"
      fill="#37363F"
    />
    <path
      d="M37.4292 11.7459L37.4282 11.4766L37.5407 11.5221C37.5759 11.5364 37.6056 11.5615 37.6257 11.5938C37.6457 11.626 37.6551 11.6638 37.6524 11.7016C37.6527 11.7912 37.6107 11.8192 37.5417 11.7913L37.4292 11.7459V11.7459ZM37.5497 11.3326L37.2738 11.2212L37.2774 12.2021L37.4311 12.2642L37.4299 11.9319L37.554 11.9821C37.7218 12.0498 37.815 11.9619 37.8143 11.7671C37.8196 11.6763 37.7971 11.5861 37.7498 11.5085C37.7025 11.4309 37.6327 11.3696 37.5497 11.3326Z"
      fill="#37363F"
    />
    <path
      d="M38.1747 11.8192L38.15 11.8092C38.0985 11.7884 38.0544 11.8043 38.0262 11.874L38.0258 11.7786L37.8807 11.72L37.8834 12.4474L38.0285 12.506L38.0271 12.1276C38.0268 12.0307 38.066 11.9962 38.1192 12.0177L38.1755 12.0404L38.1747 11.8192"
      fill="#37363F"
    />
    <path
      d="M38.4701 12.5199C38.4032 12.4929 38.3525 12.4011 38.3521 12.2723C38.3516 12.1431 38.4018 12.0935 38.4687 12.1205C38.5104 12.1459 38.5439 12.1827 38.5652 12.2266C38.5865 12.2705 38.5947 12.3196 38.5888 12.368C38.5893 12.4967 38.5381 12.5474 38.4701 12.5199ZM38.468 11.937C38.3143 11.8749 38.2013 11.9861 38.2022 12.2118C38.203 12.4374 38.3171 12.6399 38.4708 12.702C38.6255 12.7646 38.7385 12.6538 38.7377 12.4281C38.7369 12.2025 38.6227 11.9995 38.468 11.937Z"
      fill="#37363F"
    />
    <path
      d="M39.1009 11.9409L39.0268 11.9109C38.9115 11.8643 38.8439 11.9382 38.8445 12.1076L38.8445 12.1091L38.7677 12.078L38.7683 12.2391L38.8451 12.2701L38.8472 12.8364L38.993 12.8954L38.9909 12.329L39.1024 12.3741L39.1019 12.213L38.9903 12.168C38.9912 12.1052 39.0099 12.0806 39.0463 12.0952L39.1015 12.1176L39.1009 11.9409Z"
      fill="#37363F"
    />
    <path
      d="M39.3059 12.295L39.1608 12.2364L39.1634 12.9638L39.3086 13.0224L39.3059 12.295ZM39.2338 11.9677C39.1824 11.947 39.1424 11.9758 39.1427 12.0512C39.141 12.0832 39.1489 12.115 39.1653 12.1425C39.1816 12.1701 39.2058 12.1922 39.2347 12.2061C39.2848 12.2264 39.3251 12.2006 39.3248 12.1248C39.3264 12.0926 39.3186 12.0607 39.3025 12.0328C39.2863 12.005 39.2625 11.9824 39.2338 11.9677"
      fill="#37363F"
    />
    <path
      d="M39.6024 12.1748L39.4567 12.2239L39.4571 12.3571L39.3645 12.3196L39.3651 12.4807L39.4577 12.5181L39.4588 12.8152C39.4594 12.9836 39.5281 13.1121 39.6433 13.1586L39.7174 13.1886L39.7168 13.0119L39.6616 12.9895C39.6238 12.9743 39.6052 12.9335 39.6049 12.866L39.6039 12.5772L39.7154 12.6222L39.7148 12.4612L39.6033 12.4161L39.6024 12.1748Z"
      fill="#37363F"
    />
    <path
      d="M42.4832 36.1932C42.4832 36.34 42.334 36.4397 42.1984 36.3835L40.1026 35.5155C40.0257 35.4836 39.9755 35.4084 39.9755 35.3251V26.7443C39.9755 26.5979 40.1239 26.4982 40.2595 26.5536L42.3552 27.4107C42.4326 27.4424 42.4832 27.5177 42.4832 27.6014V36.1932Z"
      fill="#37363F"
    />
    <path
      d="M47.5246 38.2811C47.5246 38.4279 47.3754 38.5276 47.2397 38.4714L45.1439 37.6033C45.0669 37.5715 45.0167 37.4963 45.0167 37.413V21.3942C45.0167 21.2478 45.1652 21.1481 45.3007 21.2036L47.3965 22.0607C47.474 22.0924 47.5246 22.1677 47.5246 22.2514V38.2811Z"
      fill="#37363F"
    />
    <path
      d="M52.5654 40.2853C52.5654 40.4321 52.4162 40.5318 52.2805 40.4756L50.1848 39.6075C50.1078 39.5756 50.0576 39.5005 50.0576 39.4172V26.3444C50.0576 26.198 50.2061 26.0983 50.3416 26.1537L52.4373 27.0108C52.5148 27.0425 52.5654 27.1178 52.5654 27.2015V40.2853Z"
      fill="#37363F"
    />
    <path
      d="M57.6058 42.4283C57.6058 42.5751 57.4566 42.6748 57.3209 42.6186L55.2252 41.7505C55.1482 41.7187 55.098 41.6435 55.098 41.5602V33.9882C55.098 33.8418 55.2465 33.7421 55.382 33.7975L57.4777 34.6546C57.5552 34.6863 57.6058 34.7616 57.6058 34.8453V42.4283Z"
      fill="#37363F"
    />
    <path
      d="M62.647 44.3931C62.647 44.54 62.4978 44.6397 62.3622 44.5835L60.2665 43.7154C60.1895 43.6835 60.1393 43.6084 60.1393 43.5251V39.1C60.1393 38.9536 60.2878 38.8539 60.4233 38.9094L62.519 39.7665C62.5964 39.7982 62.647 39.8735 62.647 39.9572V44.3931Z"
      fill="#37363F"
    />
    <path
      d="M67.8 26.1657L67.7333 26.3269L76.8432 30.1003L76.9099 29.9392L67.8 26.1657Z"
      fill="#37363F"
    />
    <path
      d="M67.8 28.0481L67.7333 28.2092L72.2229 30.0689L72.2896 29.9077L67.8 28.0481Z"
      fill="#37363F"
    />
    <path
      d="M67.7681 32.8088L76.8778 36.5822V34.7512L67.7681 30.9778V32.8088Z"
      fill="#37363F"
    />
    <path
      d="M70.0782 30.873L70.0115 31.0342L73.8587 32.6278L73.9254 32.4666L70.0782 30.873Z"
      fill="#37363F"
    />
    <path
      d="M71.381 25.0341L71.3142 25.1953L73.6649 26.169L73.7317 26.0078L71.381 25.0341Z"
      fill="#37363F"
    />
    <path
      d="M71.381 24.1252L71.3142 24.2864L75.1614 25.8799L75.2282 25.7187L71.381 24.1252Z"
      fill="#37363F"
    />
    <path
      d="M70.0782 34.6008L70.0115 34.762L73.8587 36.3556L73.9254 36.1944L70.0782 34.6008Z"
      fill="#37363F"
    />
    <path
      d="M70.0782 32.7858L70.0115 32.947L73.8587 34.5406L73.9254 34.3794L70.0782 32.7858Z"
      fill="#F1F1F3"
    />
    <path
      d="M67.8 35.6042L67.7333 35.7654L72.2229 37.6251L72.2896 37.4639L67.8 35.6042Z"
      fill="#37363F"
    />
    <path
      d="M70.0782 38.4287L70.0115 38.5898L73.8587 40.1834L73.9254 40.0222L70.0782 38.4287Z"
      fill="#37363F"
    />
    <path
      d="M70.0782 42.1565L70.0115 42.3176L73.8587 43.9112L73.9254 43.75L70.0782 42.1565Z"
      fill="#37363F"
    />
    <path
      d="M70.319 44.2766L70.2522 44.4377L74.0994 46.0313L74.1661 45.8701L70.319 44.2766Z"
      fill="#37363F"
    />
    <path
      d="M70.0782 40.342L70.0115 40.5032L73.8587 42.0967L73.9254 41.9355L70.0782 40.342Z"
      fill="#37363F"
    />
    <path
      d="M67.8 44.9895L67.7333 45.1506L72.2229 47.0103L72.2896 46.8491L67.8 44.9895Z"
      fill="#37363F"
    />
    <path
      d="M70.0782 47.8147L70.0115 47.9758L73.8587 49.5694L73.9254 49.4082L70.0782 47.8147Z"
      fill="#37363F"
    />
    <path
      d="M70.0782 49.7273L70.0115 49.8884L73.8587 51.482L73.9254 51.3208L70.0782 49.7273Z"
      fill="#37363F"
    />
    <path
      d="M76.0317 32.8667V33.5858L76.4325 33.3991L76.0317 32.8667Z"
      fill="#37363F"
    />
    <path
      d="M76.0317 36.8245V37.5436L76.4325 37.3569L76.0317 36.8245Z"
      fill="#37363F"
    />
    <path
      d="M76.0317 34.9395V35.6585L76.4325 35.4719L76.0317 34.9395Z"
      fill="#F1F1F3"
    />
    <path
      d="M75.9003 18.5197C75.7202 18.4469 75.5755 18.5961 75.5764 18.8526C75.5773 19.1091 75.7236 19.3759 75.9037 19.4487C76.0834 19.5213 76.2285 19.3722 76.2276 19.1157C76.2266 18.8592 76.0801 18.5923 75.9003 18.5197Z"
      fill="#F1F1F3"
    />
    <path
      d="M76.8527 19.6687C76.7364 19.6217 76.6412 19.4484 76.6406 19.2819C76.64 19.116 76.7342 19.0187 76.8505 19.0657C76.9671 19.1128 77.0623 19.2866 77.0629 19.4526C77.0635 19.619 76.9693 19.7158 76.8527 19.6687V19.6687ZM76.8499 18.9027C76.6701 18.83 76.5251 18.9791 76.526 19.2356C76.5269 19.4921 76.6735 19.7591 76.8533 19.8317C77.0334 19.9045 77.1784 19.7554 77.1775 19.4989C77.1766 19.2424 77.03 18.9754 76.8499 18.9027"
      fill="#F1F1F3"
    />
    <path
      d="M36.2659 33.684L36.1991 33.8452L37.0436 34.1951L37.1104 34.0339L36.2659 33.684Z"
      fill="#37363F"
    />
    <path
      d="M36.2659 31.0161L36.1991 31.1772L37.0436 31.5271L37.1104 31.3659L36.2659 31.0161Z"
      fill="#37363F"
    />
    <path
      d="M36.2659 28.3486L36.1991 28.5098L37.0436 28.8596L37.1104 28.6984L36.2659 28.3486Z"
      fill="#37363F"
    />
    <path
      d="M36.2659 25.6816L36.1991 25.8428L37.0436 26.1925L37.1104 26.0314L36.2659 25.6816Z"
      fill="#37363F"
    />
    <path
      d="M36.2659 23.0134L36.1991 23.1746L37.0436 23.5244L37.1104 23.3632L36.2659 23.0134Z"
      fill="#37363F"
    />
    <path
      d="M36.435 20.2336L36.3683 20.3948L37.2128 20.7445L37.2796 20.5834L36.435 20.2336Z"
      fill="#37363F"
    />
    <path
      d="M36.4351 17.5661L36.3683 17.7273L37.2128 18.0772L37.2796 17.916L36.4351 17.5661Z"
      fill="#37363F"
    />
    <path
      d="M36.4351 14.8981L36.3683 15.0593L37.2128 15.4092L37.2796 15.248L36.4351 14.8981Z"
      fill="#37363F"
    />
    <path
      d="M65.246 47.9124L35.0143 35.3899V12.4341L65.246 25.0242V47.9124ZM35.1886 35.2734L65.0716 47.6513V25.1405L35.1886 12.6956V35.2734Z"
      fill="#37363F"
    />
    <path
      d="M38.2752 15.6365H38.1008V34.8635H38.2752V15.6365Z"
      fill="#37363F"
    />
    <path
      d="M41.3169 36.8245H41.1426V37.8701H41.3169V36.8245Z"
      fill="#37363F"
    />
    <path
      d="M46.3582 38.9453H46.1838V39.9909H46.3582V38.9453Z"
      fill="#37363F"
    />
    <path
      d="M51.3991 41.0405H51.2247V42.0861H51.3991V41.0405Z"
      fill="#37363F"
    />
    <path
      d="M56.44 43.1672H56.2656V44.2128H56.44V43.1672Z"
      fill="#37363F"
    />
    <path
      d="M61.4819 45.1262H61.3075V46.1718H61.4819V45.1262Z"
      fill="#37363F"
    />
    <path
      d="M77.9333 54.9166L60.3762 62.1848L60.443 62.346L78 55.0778L77.9333 54.9166Z"
      fill="#37363F"
    />
    <path
      d="M71.8214 55.0296L63.2944 58.5596L63.3612 58.7208L71.8881 55.1908L71.8214 55.0296Z"
      fill="#37363F"
    />
    <path
      d="M33.7879 0.00812666L16.2308 7.27637L16.2976 7.43756L33.8546 0.169318L33.7879 0.00812666Z"
      fill="#37363F"
    />
    <path
      d="M31.3782 3.23236L23.6277 6.44092L23.6944 6.60211L31.445 3.39354L31.3782 3.23236Z"
      fill="#37363F"
    />
    <path
      d="M7.64017 12.7336L50.7302 30.5821C50.9525 30.6742 51.1426 30.8301 51.2763 31.0302C51.41 31.2303 51.4813 31.4656 51.4813 31.7062V67.5533L7.08643 49.1643V13.1036C7.08643 13.0377 7.10267 12.9729 7.13372 12.9148C7.16476 12.8567 7.20965 12.8072 7.26441 12.7706C7.31917 12.734 7.38211 12.7115 7.44765 12.7051C7.5132 12.6986 7.57932 12.7084 7.64017 12.7336Z"
      fill="white"
    />
    <path
      d="M51.5693 67.6839L51.4487 67.634L7 49.2226V13.1036C7 13.0234 7.01978 12.9445 7.05759 12.8738C7.09539 12.803 7.15006 12.7427 7.21674 12.6982C7.28343 12.6536 7.36007 12.6262 7.43988 12.6183C7.5197 12.6105 7.60022 12.6224 7.67432 12.6531L50.7644 30.5015C51.0029 30.5998 51.2069 30.7668 51.3502 30.9814C51.4935 31.1959 51.5698 31.4483 51.5693 31.7063V67.6839ZM7.17436 49.1061L51.3949 67.4229V31.7063C51.3953 31.4828 51.3293 31.2642 51.2051 31.0784C51.0809 30.8925 50.9043 30.7478 50.6976 30.6627L7.60759 12.8143C7.55999 12.7945 7.50826 12.7868 7.45698 12.7919C7.40571 12.7969 7.35646 12.8145 7.31362 12.8431C7.27077 12.8718 7.23565 12.9105 7.21136 12.9559C7.18707 13.0014 7.17436 13.0521 7.17436 13.1036V49.1061Z"
      fill="#29292F"
    />
    <path
      d="M40.3583 31.7261H40.184V63.0846H40.3583V31.7261Z"
      fill="#29292F"
    />
    <path
      d="M7.13818 18.5344L51.4203 36.9385V33.7784L7.13818 15.3743V18.8062"
      fill="#F1F1F3"
    />
    <path
      d="M7.68964 12.808L50.6929 30.6242C50.9082 30.7137 51.0922 30.8653 51.2217 31.0598C51.3512 31.2543 51.4203 31.483 51.4203 31.7169V33.8325L7.13818 15.4191V13.2008C7.13818 13.135 7.15469 13.0471 7.18559 12.9891C7.21649 12.9311 7.26117 12.8816 7.31567 12.845C7.37017 12.8085 7.43281 12.786 7.49804 12.7795C7.56327 12.7731 7.62908 12.7829 7.68964 12.808Z"
      fill="#37363F"
    />
    <path
      d="M8.22313 16.8224C8.0238 16.7418 7.88917 16.8385 7.88995 17.0539C7.89086 17.1506 7.91515 17.2456 7.96073 17.3309C8.00632 17.4163 8.07185 17.4893 8.15174 17.5438L8.23352 17.6091C8.33864 17.6921 8.39158 17.7419 8.39185 17.8168C8.39212 17.8917 8.33227 17.9173 8.23449 17.8778C8.1775 17.8465 8.12894 17.8019 8.09301 17.7477C8.05707 17.6935 8.03481 17.6314 8.02815 17.5667L7.86035 17.5825C7.91041 17.8784 8.06348 18.0487 8.23536 18.1182C8.45595 18.2073 8.5892 18.1081 8.58836 17.8766C8.58667 17.7789 8.56096 17.683 8.51352 17.5976C8.46608 17.5121 8.39835 17.4396 8.3163 17.3864L8.2335 17.3227C8.1483 17.256 8.08919 17.2023 8.08889 17.1201C8.08865 17.0525 8.13754 17.0278 8.22502 17.0631C8.27711 17.0874 8.32168 17.1253 8.35405 17.1728C8.38642 17.2203 8.40538 17.2756 8.40894 17.3329L8.58162 17.3387C8.57333 17.2285 8.53572 17.1225 8.47269 17.0317C8.40965 16.9409 8.32349 16.8686 8.22313 16.8224Z"
      fill="#29292F"
    />
    <path
      d="M8.96488 18.226C8.93195 18.2152 8.90305 18.1947 8.88198 18.1671C8.86091 18.1396 8.84866 18.1063 8.84682 18.0717C8.84658 18.0042 8.89275 17.9837 8.96411 18.0126C8.99712 18.0234 9.02609 18.0439 9.04723 18.0714C9.06836 18.099 9.08067 18.1323 9.08252 18.167C9.08277 18.2345 9.03659 18.255 8.96488 18.226ZM8.96342 17.4414C8.83442 17.3893 8.71941 17.4156 8.67141 17.5971L8.82443 17.7533C8.84779 17.6772 8.89153 17.645 8.95671 17.6713C8.99648 17.6883 9.02974 17.7176 9.05153 17.7549C9.07333 17.7923 9.08251 17.8356 9.07771 17.8786L9.07798 17.9535C9.04228 17.8909 8.98662 17.8421 8.9199 17.8148C8.75316 17.7475 8.65718 17.828 8.6578 17.9988C8.65448 18.0813 8.67643 18.1628 8.7207 18.2325C8.76497 18.3022 8.82945 18.3567 8.90553 18.3887C8.93563 18.4073 8.97163 18.4139 9.00637 18.4072C9.04112 18.4005 9.07209 18.381 9.09313 18.3526L9.09345 18.4417L9.26396 18.5106L9.26185 17.9281C9.26663 17.8264 9.24073 17.7256 9.18751 17.6388C9.13429 17.552 9.05621 17.4833 8.96341 17.4414"
      fill="#29292F"
    />
    <path
      d="M9.55673 17.3842L9.37146 17.3093L9.37495 18.2727C9.37559 18.4508 9.44872 18.5855 9.57257 18.6355L9.65525 18.6689L9.65444 18.4442L9.6095 18.4261C9.57553 18.4123 9.56034 18.3813 9.56016 18.3318L9.55673 17.3842Z"
      fill="#29292F"
    />
    <path
      d="M9.89245 18.187C9.90817 18.0834 9.95054 18.0487 10.0195 18.0765C10.0809 18.1013 10.1264 18.1696 10.1443 18.2887L9.89245 18.187ZM10.0187 17.8685C9.8297 17.7921 9.69867 17.9381 9.69971 18.225C9.70077 18.5172 9.83562 18.7652 10.0325 18.8448C10.1701 18.9004 10.285 18.8456 10.332 18.6583L10.1763 18.5172C10.1455 18.6221 10.0956 18.6478 10.0228 18.6185C9.94872 18.5885 9.89842 18.5095 9.88794 18.3597L10.3302 18.5383C10.3315 18.5213 10.3314 18.4978 10.3313 18.4801C10.3303 18.1918 10.203 17.9429 10.0187 17.8685"
      fill="#29292F"
    />
    <path
      d="M10.6824 18.1375C10.5181 18.0712 10.4135 18.1413 10.4141 18.3122C10.4147 18.4634 10.4812 18.5793 10.6354 18.6948L10.6983 18.7417C10.7711 18.7961 10.8024 18.8283 10.8026 18.8743C10.8027 18.9208 10.7627 18.9315 10.6975 18.9052C10.6527 18.883 10.6145 18.8496 10.5867 18.808C10.5589 18.7665 10.5425 18.7185 10.5391 18.6686L10.3928 18.6784C10.4022 18.771 10.4352 18.8596 10.4887 18.9358C10.5422 19.0119 10.6144 19.073 10.6983 19.1132C10.8664 19.1811 10.9775 19.1087 10.9768 18.9325C10.9746 18.8584 10.9544 18.7859 10.918 18.7213C10.8816 18.6567 10.8301 18.6019 10.7679 18.5616L10.705 18.5147C10.627 18.4568 10.5872 18.4266 10.587 18.3766C10.5869 18.3375 10.6231 18.3218 10.6832 18.3461C10.7223 18.3637 10.7557 18.392 10.7795 18.4277C10.8033 18.4635 10.8166 18.5052 10.8178 18.5481L10.9689 18.552C10.9634 18.4633 10.9338 18.3779 10.8833 18.3049C10.8328 18.2319 10.7634 18.174 10.6824 18.1375Z"
      fill="#29292F"
    />
    <path
      d="M11.2761 18.6662L11.2748 18.324L11.4175 18.3817C11.4622 18.3999 11.5 18.4318 11.5255 18.4727C11.5511 18.5137 11.5631 18.5616 11.5598 18.6098C11.5603 18.7238 11.5066 18.7593 11.4188 18.7238L11.276 18.6662H11.2761ZM11.429 18.1409L11.0784 17.9993L11.0829 19.246L11.2784 19.325L11.2769 18.9031L11.4347 18.9668C11.6478 19.0529 11.7659 18.9403 11.765 18.6926C11.7718 18.5774 11.7432 18.4629 11.6832 18.3643C11.6231 18.2657 11.5345 18.1878 11.429 18.1409Z"
      fill="#29292F"
    />
    <path
      d="M12.1501 19.4689C12.0651 19.4345 12.0006 19.318 12 19.154C11.9994 18.9901 12.0632 18.9269 12.1483 18.9613C12.2348 18.9962 12.3003 19.1116 12.3009 19.2756C12.3015 19.4396 12.2366 19.5038 12.1501 19.4689H12.1501ZM12.1475 18.7283C11.9519 18.6493 11.8085 18.7903 11.8096 19.0771C11.8106 19.364 11.9554 19.6214 12.151 19.7004C12.3476 19.7798 12.4909 19.6388 12.4899 19.352C12.4889 19.0651 12.3441 18.8077 12.1475 18.7283Z"
      fill="#29292F"
    />
    <path
      d="M13.4822 19.2918L13.2879 19.2134L13.1922 19.7206L13.0773 19.1283L12.9119 19.0615L12.8024 19.5666L12.703 18.9771L12.5061 18.8975L12.7036 19.9001L12.8879 19.9745L12.995 19.4826L13.1057 20.0625L13.2927 20.1381L13.4822 19.2918Z"
      fill="#29292F"
    />
    <path
      d="M13.6965 19.7234C13.7122 19.6198 13.7546 19.5851 13.8236 19.613C13.885 19.6378 13.9301 19.7058 13.948 19.825L13.6965 19.7234ZM13.8228 19.4049C13.6334 19.3284 13.5028 19.4745 13.5038 19.7614C13.5048 20.0536 13.6397 20.3016 13.8363 20.3811C13.9742 20.4368 14.0891 20.382 14.136 20.1947L13.9803 20.0536C13.9492 20.1584 13.8993 20.1841 13.8269 20.1549C13.7528 20.1249 13.7025 20.046 13.692 19.8961L14.1342 20.0747C14.1355 20.0577 14.1355 20.0342 14.1354 20.0166C14.1343 19.7283 14.007 19.4794 13.8228 19.4049Z"
      fill="#29292F"
    />
    <path
      d="M14.6017 19.7203L14.5705 19.7077C14.5053 19.6814 14.4492 19.7012 14.4132 19.7898L14.4127 19.6689L14.2285 19.5945L14.2319 20.5186L14.4161 20.5931L14.4144 20.1119C14.4139 19.989 14.4638 19.9456 14.5314 19.9729L14.6027 20.0018L14.6017 19.7203Z"
      fill="#29292F"
    />
    <path
      d="M37.1783 34.8762C37.0188 34.8117 36.9562 34.9419 36.9388 35.0664L37.0691 35.1791C37.0798 35.1135 37.1052 35.0397 37.179 35.0695C37.205 35.0832 37.2265 35.104 37.2411 35.1294C37.2557 35.1549 37.2628 35.184 37.2614 35.2133C37.2614 35.2379 37.2561 35.2623 37.246 35.2847C37.2359 35.3072 37.2211 35.3272 37.2026 35.3435L36.9556 35.6191L36.9562 35.7845L37.4217 35.9726L37.421 35.7847L37.1555 35.6774L37.3125 35.5086C37.3463 35.4779 37.3732 35.4403 37.3915 35.3984C37.4097 35.3564 37.4188 35.3111 37.4181 35.2654C37.4217 35.184 37.4007 35.1034 37.3579 35.034C37.3152 34.9646 37.2526 34.9096 37.1783 34.8762"
      fill="#29292F"
    />
    <path
      d="M37.77 35.9399C37.6832 35.9048 37.6523 35.776 37.6515 35.5753C37.6508 35.3751 37.6809 35.2709 37.7677 35.306C37.8545 35.3411 37.8855 35.4699 37.8862 35.6701C37.8869 35.8708 37.8568 35.975 37.77 35.9399H37.77ZM37.767 35.1141C37.6102 35.0508 37.4935 35.1673 37.4948 35.5134C37.496 35.857 37.6139 36.0684 37.7707 36.1318C37.9275 36.1951 38.0442 36.0785 38.043 35.7349C38.0417 35.3889 37.9238 35.1775 37.767 35.1141Z"
      fill="#29292F"
    />
    <path
      d="M38.3379 35.3452C38.178 35.2807 38.1154 35.4108 38.0984 35.5354L38.2286 35.6481C38.239 35.5825 38.2645 35.5087 38.3386 35.5386C38.3645 35.5523 38.3859 35.573 38.4005 35.5985C38.415 35.6239 38.422 35.6529 38.4206 35.6822C38.4206 35.7068 38.4153 35.7312 38.4053 35.7536C38.3952 35.7761 38.3805 35.7962 38.3621 35.8125L38.1151 36.0881L38.1157 36.2536L38.5809 36.4415L38.5803 36.2536L38.3151 36.1464L38.472 35.9777C38.5058 35.9469 38.5327 35.9093 38.5508 35.8673C38.569 35.8253 38.578 35.78 38.5774 35.7343C38.5809 35.6529 38.56 35.5724 38.5173 35.503C38.4746 35.4337 38.4121 35.3787 38.3379 35.3452"
      fill="#29292F"
    />
    <path
      d="M38.8893 35.5859L38.644 35.4868L38.6447 35.6748L38.7411 35.7137L38.744 36.5073L38.8929 36.5674L38.8893 35.5859Z"
      fill="#29292F"
    />
    <path
      d="M8.93552 23.0637L8.36731 22.8342L8.36802 23.028L8.57523 23.1118L8.57816 23.8994L8.73186 23.9614L8.72893 23.1738L8.93623 23.2576L8.93552 23.0637Z"
      fill="#29292F"
    />
    <path
      d="M9.12627 23.9576C9.05902 23.9304 9.00867 23.8387 9.00821 23.7094C9.00774 23.5807 9.05758 23.5309 9.12481 23.5581C9.16639 23.5834 9.1998 23.6201 9.22105 23.6639C9.24229 23.7077 9.25046 23.7567 9.24459 23.805C9.24506 23.9342 9.19419 23.985 9.12626 23.9576H9.12627ZM9.12415 23.3746C8.9701 23.3123 8.85746 23.4232 8.85828 23.6489C8.8591 23.8745 8.97288 24.0774 9.12693 24.1396C9.28166 24.2022 9.39431 24.0908 9.39349 23.8651C9.39267 23.6395 9.27888 23.4371 9.12415 23.3746"
      fill="#29292F"
    />
    <path
      d="M9.65163 23.3657L9.50622 23.415L9.5067 23.5481L9.41406 23.5107L9.41465 23.6717L9.50728 23.7092L9.50836 24.0063C9.50897 24.1747 9.57727 24.303 9.69254 24.3495L9.76665 24.3795L9.76601 24.2028L9.71077 24.1805C9.67337 24.1653 9.65438 24.1239 9.65414 24.0569L9.65309 23.7681L9.76459 23.8131L9.76401 23.6521L9.65251 23.607L9.65163 23.3657Z"
      fill="#29292F"
    />
    <path
      d="M10.0513 24.3655C10.0254 24.357 10.0027 24.3409 9.98608 24.3193C9.96949 24.2977 9.95983 24.2715 9.95835 24.2443C9.95815 24.191 9.99441 24.1748 10.0507 24.1976C10.0766 24.2061 10.0994 24.2223 10.116 24.244C10.1326 24.2657 10.1422 24.2919 10.1436 24.3192C10.1438 24.3721 10.1075 24.3882 10.0513 24.3655ZM10.0501 23.7481C9.94852 23.7071 9.85816 23.7278 9.8203 23.8709L9.94065 23.9933C9.95928 23.9339 9.99344 23.9085 10.0449 23.9293C10.0762 23.9427 10.1023 23.9658 10.1195 23.9951C10.1366 24.0245 10.1438 24.0586 10.14 24.0924L10.1403 24.1512C10.1122 24.1019 10.0684 24.0635 10.0158 24.0422C9.88479 23.9893 9.80897 24.052 9.80946 24.1866C9.80685 24.2516 9.82413 24.3158 9.85897 24.3706C9.89382 24.4255 9.94458 24.4684 10.0045 24.4937C10.0281 24.5083 10.0564 24.5135 10.0838 24.5082C10.1111 24.503 10.1355 24.4877 10.152 24.4653L10.1523 24.5353L10.2864 24.5895L10.2848 24.1308C10.2885 24.0509 10.2682 23.9716 10.2263 23.9034C10.1845 23.8351 10.1231 23.781 10.0501 23.7481"
      fill="#29292F"
    />
    <path
      d="M10.5178 23.7027L10.3719 23.6438L10.3747 24.4025C10.3688 24.4602 10.3804 24.5183 10.4082 24.5693C10.436 24.6202 10.4785 24.6615 10.5302 24.6877L10.5954 24.7141L10.5948 24.5374L10.5591 24.523C10.5327 24.5123 10.5206 24.4878 10.5205 24.4487L10.5178 23.7027Z"
      fill="#29292F"
    />
    <path
      d="M11.0032 24.3611L11.0022 24.0924L11.1147 24.1378C11.1498 24.1521 11.1796 24.1771 11.1997 24.2093C11.2198 24.2415 11.2293 24.2791 11.2267 24.317C11.227 24.4071 11.1846 24.4344 11.1157 24.4066L11.0032 24.3611ZM11.124 23.948L10.8478 23.8364L10.8513 24.8179L11.005 24.8799L11.0038 24.5476L11.128 24.5978C11.2958 24.6655 11.389 24.5771 11.3883 24.3823C11.3935 24.2916 11.371 24.2015 11.3238 24.1239C11.2766 24.0464 11.2069 23.985 11.124 23.948"
      fill="#29292F"
    />
    <path
      d="M11.749 24.4349L11.7243 24.4249C11.6729 24.4041 11.6287 24.4195 11.6005 24.4893L11.6002 24.3943L11.4551 24.3357L11.4577 25.0631L11.6028 25.1217L11.6015 24.7433C11.6011 24.6464 11.6404 24.6119 11.6936 24.6334L11.7498 24.6562L11.749 24.4349"
      fill="#29292F"
    />
    <path
      d="M12.0445 25.1352C11.9776 25.1082 11.9269 25.0163 11.9264 24.8871C11.9259 24.7584 11.9761 24.7088 12.043 24.7358C12.0847 24.761 12.1182 24.7978 12.1395 24.8416C12.1608 24.8854 12.169 24.9344 12.1631 24.9828C12.1636 25.112 12.1128 25.1628 12.0445 25.1352ZM12.0424 24.5522C11.8887 24.4901 11.7757 24.6009 11.7765 24.8266C11.7773 25.0522 11.8914 25.2552 12.0451 25.3173C12.1999 25.3798 12.3129 25.2686 12.312 25.0429C12.3112 24.8173 12.1971 24.6148 12.0424 24.5522"
      fill="#29292F"
    />
    <path
      d="M12.6749 24.5568L12.6011 24.527C12.4855 24.4803 12.4179 24.5537 12.4185 24.7235L12.4185 24.725L12.3417 24.6939L12.3423 24.855L12.4191 24.886L12.4212 25.4524L12.567 25.5113L12.5649 24.9449L12.6764 24.99L12.6758 24.8289L12.5643 24.7839C12.5651 24.7212 12.5839 24.6965 12.6203 24.7112L12.6755 24.7335L12.6749 24.5568Z"
      fill="#29292F"
    />
    <path
      d="M12.8803 24.9115L12.7355 24.853L12.7381 25.5804L12.8829 25.6389L12.8803 24.9115ZM12.8082 24.5842C12.757 24.5635 12.7167 24.5917 12.717 24.6676C12.7154 24.6996 12.7233 24.7314 12.7397 24.759C12.756 24.7865 12.7802 24.8087 12.809 24.8226C12.8595 24.843 12.8998 24.8172 12.8995 24.7414C12.9011 24.7091 12.8933 24.6771 12.8771 24.6492C12.8609 24.6213 12.837 24.5988 12.8082 24.5842Z"
      fill="#29292F"
    />
    <path
      d="M13.1764 24.7905L13.031 24.8398L13.0314 24.9729L12.9385 24.9354L12.9391 25.0964L13.032 25.134L13.0331 25.4311C13.0337 25.5995 13.102 25.7278 13.2173 25.7743L13.2914 25.8043L13.2908 25.6276L13.2355 25.6053C13.1978 25.59 13.1791 25.5488 13.1789 25.4817L13.1778 25.1929L13.2893 25.2379L13.2888 25.0769L13.1773 25.0318L13.1764 24.7905Z"
      fill="#29292F"
    />
    <path
      d="M16.0567 48.8092C16.0567 48.956 15.9075 49.0557 15.7719 48.9995L13.6761 48.1314C13.5991 48.0996 13.549 48.0244 13.549 47.9411V37.6748C13.549 37.5283 13.6974 37.4286 13.8329 37.4841L15.9287 38.3412C16.0061 38.3729 16.0567 38.4483 16.0567 38.5319V48.8092Z"
      fill="#29292F"
    />
    <path
      d="M21.0981 50.8965C21.0981 51.0433 20.9489 51.143 20.8132 51.0868L18.7174 50.2187C18.6404 50.1868 18.5902 50.1117 18.5902 50.0284V34.0097C18.5902 33.8633 18.7387 33.7636 18.8742 33.819L20.97 34.6761C21.0475 34.7078 21.0981 34.7831 21.0981 34.8668V50.8965Z"
      fill="#29292F"
    />
    <path
      d="M26.1389 52.9013C26.1389 53.0481 25.9897 53.1478 25.854 53.0916L23.7583 52.2235C23.6813 52.1917 23.6311 52.1165 23.6311 52.0332V38.9604C23.6311 38.814 23.7796 38.7143 23.9151 38.7697L26.0108 39.6268C26.0883 39.6585 26.1389 39.7338 26.1389 39.8175V52.9013Z"
      fill="#29292F"
    />
    <path
      d="M31.1808 55.0443C31.1808 55.1911 31.0316 55.2908 30.896 55.2346L28.8003 54.3665C28.7233 54.3346 28.6731 54.2595 28.6731 54.1762V46.6042C28.6731 46.4578 28.8216 46.3581 28.9571 46.4135L31.0528 47.2707C31.1303 47.3023 31.1808 47.3777 31.1808 47.4614V55.0443Z"
      fill="#29292F"
    />
    <path
      d="M36.2212 57.009C36.2212 57.1558 36.072 57.2555 35.9364 57.1994L33.8407 56.3313C33.7637 56.2994 33.7135 56.2243 33.7135 56.141V51.716C33.7135 51.5696 33.862 51.4699 33.9975 51.5253L36.0932 52.3824C36.1707 52.4141 36.2212 52.4894 36.2212 52.5731V57.009Z"
      fill="#29292F"
    />
    <path
      d="M41.3738 38.7812L41.307 38.9424L50.4168 42.7158L50.4836 42.5546L41.3738 38.7812Z"
      fill="#29292F"
    />
    <path
      d="M41.3738 40.664L41.307 40.8252L45.7966 42.6849L45.8634 42.5237L41.3738 40.664Z"
      fill="#37363F"
    />
    <path
      d="M41.3417 45.4252L50.4515 49.1987V47.3676L41.3417 43.5942V45.4252Z"
      fill="#37363F"
    />
    <path
      d="M43.6503 43.489L43.5835 43.6501L47.4307 45.2437L47.4974 45.0825L43.6503 43.489Z"
      fill="#37363F"
    />
    <path
      d="M44.9541 37.6504L44.8873 37.8115L47.238 38.7852L47.3048 38.624L44.9541 37.6504Z"
      fill="#37363F"
    />
    <path
      d="M44.9541 36.7414L44.8873 36.9026L48.7345 38.4961L48.8013 38.335L44.9541 36.7414Z"
      fill="#37363F"
    />
    <path
      d="M43.6503 47.2167L43.5835 47.3779L47.4307 48.9715L47.4974 48.8103L43.6503 47.2167Z"
      fill="#37363F"
    />
    <path
      d="M43.6503 45.4018L43.5835 45.563L47.4307 47.1565L47.4974 46.9953L43.6503 45.4018Z"
      fill="white"
    />
    <path
      d="M41.3738 48.2197L41.307 48.3809L45.7966 50.2404L45.8634 50.0793L41.3738 48.2197Z"
      fill="#37363F"
    />
    <path
      d="M43.6503 51.0446L43.5835 51.2058L47.4307 52.7994L47.4974 52.6382L43.6503 51.0446Z"
      fill="#37363F"
    />
    <path
      d="M43.6503 54.7724L43.5835 54.9336L47.4307 56.5271L47.4974 56.366L43.6503 54.7724Z"
      fill="#37363F"
    />
    <path
      d="M43.6503 56.6586L43.5835 56.8198L47.4307 58.4134L47.4974 58.2522L43.6503 56.6586Z"
      fill="#37363F"
    />
    <path
      d="M43.6503 52.9575L43.5835 53.1187L47.4307 54.7122L47.4974 54.551L43.6503 52.9575Z"
      fill="#37363F"
    />
    <path
      d="M41.3738 57.6057L41.307 57.7668L45.7966 59.6264L45.8634 59.4653L41.3738 57.6057Z"
      fill="#37363F"
    />
    <path
      d="M43.6503 60.4306L43.5835 60.5918L47.4307 62.1854L47.4974 62.0242L43.6503 60.4306Z"
      fill="#37363F"
    />
    <path
      d="M43.6503 62.3432L43.5835 62.5044L47.4307 64.0979L47.4974 63.9367L43.6503 62.3432Z"
      fill="#37363F"
    />
    <path
      d="M49.606 45.4822V46.2013L50.0067 46.0146L49.606 45.4822Z"
      fill="#37363F"
    />
    <path
      d="M49.606 49.4412V50.1602L50.0067 49.9736L49.606 49.4412Z"
      fill="#37363F"
    />
    <path
      d="M49.606 47.5549V48.274L50.0067 48.0874L49.606 47.5549Z"
      fill="white"
    />
    <path
      d="M9.83984 46.2995L9.77307 46.4607L10.6176 46.8105L10.6844 46.6494L9.83984 46.2995Z"
      fill="#37363F"
    />
    <path
      d="M9.83984 43.6325L9.77307 43.7937L10.6176 44.1436L10.6844 43.9824L9.83984 43.6325Z"
      fill="#37363F"
    />
    <path
      d="M9.83983 40.9645L9.77307 41.1257L10.6176 41.4755L10.6844 41.3143L9.83983 40.9645Z"
      fill="#37363F"
    />
    <path
      d="M9.83984 38.2971L9.77307 38.4583L10.6176 38.8081L10.6844 38.6469L9.83984 38.2971Z"
      fill="#37363F"
    />
    <path
      d="M9.83984 35.6289L9.77307 35.79L10.6176 36.1399L10.6844 35.9787L9.83984 35.6289Z"
      fill="#37363F"
    />
    <path
      d="M10.0092 32.8491L9.94238 33.0103L10.7869 33.3601L10.8537 33.1989L10.0092 32.8491Z"
      fill="#37363F"
    />
    <path
      d="M10.0092 30.1816L9.94238 30.3428L10.7869 30.6926L10.8537 30.5314L10.0092 30.1816Z"
      fill="#37363F"
    />
    <path
      d="M10.0092 27.5141L9.94238 27.6753L10.7869 28.0251L10.8537 27.864L10.0092 27.5141Z"
      fill="#37363F"
    />
    <path
      d="M38.8186 60.5283L8.58704 48.0059V25.05L38.8186 37.6403V60.5283ZM8.7614 47.8894L38.6443 60.2673V37.7566L8.7614 25.3116V47.8894Z"
      fill="#37363F"
    />
    <path
      d="M11.8472 28.2524H11.6729V47.4795H11.8472V28.2524Z"
      fill="#37363F"
    />
    <path
      d="M14.8898 49.4412H14.7155V50.4867H14.8898V49.4412Z"
      fill="#37363F"
    />
    <path
      d="M19.9311 51.5613H19.7567V52.6069H19.9311V51.5613Z"
      fill="#37363F"
    />
    <path
      d="M24.972 53.6558H24.7976V54.7013H24.972V53.6558Z"
      fill="#37363F"
    />
    <path
      d="M30.0132 55.7832H29.8389V56.8288H30.0132V55.7832Z"
      fill="#37363F"
    />
    <path
      d="M35.055 57.7424H34.8806V58.788H35.055V57.7424Z"
      fill="#37363F"
    />
    <path
      d="M7.11957 18.4964L7.0531 18.6577L51.448 36.9496L51.5145 36.7883L7.11957 18.4964Z"
      fill="#29292F"
    />
  </svg>
);
const SvgActionDemo = (props: IllustrationProps) => (
  <SVGUniqueID>{Illustration(props)}</SVGUniqueID>
);
export default SvgActionDemo;
